import {PurchasePriceRuleResponseBody} from '@dms/api/sales';
import {i18n} from '@dms/i18n';

import {toPurchasePriceRuleFormValues} from './toPurchasePriceRuleFormValues';

/** The system rule shows the translated default name instead of its technical name. */
export const responseToFormValues = (rule: PurchasePriceRuleResponseBody) =>
  toPurchasePriceRuleFormValues(rule, {
    name: rule.system
      ? i18n.t('page.settings.purchasePrice.marginRules.systemRule.title')
      : rule.name,
    scope: {
      makes: rule.scope?.makes ?? [],
      modelFamilies: rule.scope?.modelFamilies ?? [],
      trims: rule.scope?.trims ?? [],
    },
  });
